/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_Policy_Security_Rest_LabelInputs */

const es_privacy_policy_security_rest_label = /** @type {(inputs: Privacy_Policy_Security_Rest_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cifrado en Reposo`)
};

const en_privacy_policy_security_rest_label = /** @type {(inputs: Privacy_Policy_Security_Rest_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Encryption at Rest`)
};

/**
* | output |
* | --- |
* | "Encryption at Rest" |
*
* @param {Privacy_Policy_Security_Rest_LabelInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const privacy_policy_security_rest_label = /** @type {((inputs?: Privacy_Policy_Security_Rest_LabelInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_Policy_Security_Rest_LabelInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_privacy_policy_security_rest_label(inputs)
	return en_privacy_policy_security_rest_label(inputs)
});
export { privacy_policy_security_rest_label as "privacy_policy.security.rest_label" }